import { render, staticRenderFns } from "./callCamera.vue?vue&type=template&id=55982091&scoped=true&"
import script from "./callCamera.vue?vue&type=script&lang=js&"
export * from "./callCamera.vue?vue&type=script&lang=js&"
import style0 from "./callCamera.vue?vue&type=style&index=0&id=55982091&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55982091",
  null
  
)

export default component.exports